<template>
  <div>
    <CardCadastro v-for="(item, index) in textos" :key="index" classBase=" " classBase2=" ">
      <div slot="header">
        <h4 class="title">{{item.titulo}}</h4>
      </div>
      <div slot="body">
        <textarea v-model="item.texto" style="height: 50px; width: 100%"></textarea>
      </div>
    </CardCadastro>
  </div>
</template>
<script>
import CardCadastro from "../../../components/CardCadastro";

export default {
  components: {
    CardCadastro
  },
  model: {
    prop: "textos",
    event: "selected"
  },
  props: {
    textos: {
      type: Array,
      default: []
    }
  }
};
</script>

